var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/warning.tsx";
import React from 'react';
import { spring } from 'react-motion';
import Motion from '../../ui/util/optional-motion';

/** Warning message displayed in ComposeForm. */
const Warning = _ref => {
  let {
    message
  } = _ref;
  return /*#__PURE__*/React.createElement(Motion, {
    defaultStyle: {
      opacity: 0,
      scaleX: 0.85,
      scaleY: 0.75
    },
    style: {
      opacity: spring(1, {
        damping: 35,
        stiffness: 400
      }),
      scaleX: spring(1, {
        damping: 35,
        stiffness: 400
      }),
      scaleY: spring(1, {
        damping: 35,
        stiffness: 400
      })
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 3
    }
  }, _ref2 => {
    let {
      opacity,
      scaleX,
      scaleY
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: "compose-form__warning",
      style: {
        opacity: opacity,
        transform: "scale(".concat(scaleX, ", ").concat(scaleY, ")")
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14,
        columnNumber: 7
      }
    }, message);
  });
};

export default Warning;